import { useEffect, useContext } from "react";

//material-ui
import { Button, Grid, Paper } from "@mui/material";

import { AuthContext } from "../auth/AuthProvider";

import SFGLogo from "../assets/SF-Logo-foronwhite.svg";
import SFGLogoDark from "../assets/SFLogoDark.svg";

const Forbidden = (props: any) => {
	const pageTitle = "Inventory";

	const pageButtons: any = [{}];

	const authContext = useContext(AuthContext);

	const pageCallbacks = async () => {
		props.setTheme("main");
		props.setPageTitle(pageTitle);
		props.setPageButtons(pageButtons);
	};

	useEffect(() => {
		pageCallbacks();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Grid container alignItems="center">
			<Grid item xs={12}>
				<h1>Not Authorized</h1>
				<p>Your account does not have access to this application. Please contact your administrator.</p>
			</Grid>
			<Grid item xs={12}>
				<Button variant="outlined" onClick={() => authContext.redirectToLogout()}>
					Try Logging In Again
				</Button>
			</Grid>
			<Paper style={{ padding: "1em", textAlign: "center" }}>
				<img alt="SFG Logo" src={props.themeType === "dark" ? SFGLogoDark : SFGLogo} style={{ width: "80%", maxWidth: "500px" }} />
			</Paper>
			<Grid item xs={12}>
				<p>Build Version: {__APP_VERSION__}</p>
			</Grid>
		</Grid>
	);
};
export default Forbidden;
